import Page500 from './components/500';

export default Page500;


// WEBPACK FOOTER //
// ./routes/500/index.js